import * as angular from 'angular';
import { versionCompare } from './version-compare.helper';
import { UADetect } from './ua-detect.service';

export const detectModule = angular.module('detect', [])
	.value('versionCompare', versionCompare)
	.service('UADetect', UADetect)
	.name;
